import React from 'react';

import { ConfirmModal } from '~/components/ConfirmModal';

interface DeleteProfileInUseModalProps {
  isOpen: boolean;
  assignedUserCount: number;
  onClose: () => void;
}

const DeleteProfileInUseModal: React.FC<DeleteProfileInUseModalProps> = ({ isOpen, assignedUserCount, onClose }) => (
  <ConfirmModal
    isOpen={isOpen}
    onClose={onClose}
    onPrimaryBtnClick={onClose}
    title="Cannot delete profile"
    contentText={`${assignedUserCount} user(s) are still assigned to this profile. Reassign them before deleting.`}
    primaryButtonName="Close"
    removeSecondaryButton
  />
);

export default DeleteProfileInUseModal;
